import AffiliateList from "./AffiliateList";
import AffiliateReport from "./AffiliateReport";

const Affiliate = () => {
  return (
    <>
      <AffiliateList />
      <AffiliateReport />
    </>
  );
};

export default (Affiliate);